import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import RegisterPage from "./pages/Register";
import LoginPage from "./pages/Login";
import Navbar from "./layouts/Navbar";
import Footer from "./layouts/Footer";
import QuickOrderPage from "./pages/QuickOrder";
import OrderNowPage from "./pages/OrderNow";
import TrackNowPage from "./pages/TrackNow";
import SuccessPage from "./pages/success";
import CancelPage from "./pages/cancel";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BackToTop from "./components/BackToTop";
import useScrollReveal from "./hooks/useScrollReveal";
import { HelmetProvider } from "react-helmet-async";

// Scroll to the hash target on arrival, otherwise reset to the top on navigation.
const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location]);

  return null;
};

const AppShell = () => {
  useScrollReveal();

  return (
    <>
      <ScrollManager />
      <Navbar />
      <main id="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/quick-order/:campaignId" element={<QuickOrderPage />} />
          <Route path="/order-now" element={<OrderNowPage />} />
          <Route path="/track-order" element={<TrackNowPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <AppShell />
      </Router>
    </HelmetProvider>
  );
};

export default App;
